/**
 * PHI DIGITAL - Módulo Janis Commerce (Ventanas de Entrega Dinámicas)
 */
async function recalcularFechasJanis() {
  try {
    const res = await fetch((window.routes ? window.routes.cart_url : "/cart") + ".js");
    if (!res.ok) return;
    const cartData = await res.json();

    // 1. Limpieza si el carrito se vacía
    if (!cartData.items || cartData.items.length === 0) {
      const formDataVacio = new URLSearchParams();
      formDataVacio.append("attributes[_janisCommerce_deliveryWindowFrom]", "");
      formDataVacio.append("attributes[_janisCommerce_deliveryWindowTo]", "");

      await fetch((window.routes ? window.routes.cart_update_url : "/cart/update") + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formDataVacio
      });
      return;
    }

    const fechasPreventa = [];

    // 2. Escanear ítems en búsqueda de fechas de preventa
    cartData.items.forEach((item) => {
      const properties = item.properties || {};
      const fechaOriginal = properties["_janisCommerce_preventaDate"] || properties["_janisCommerce_preventa"] || null;

      if (fechaOriginal && typeof fechaOriginal === "string") {
        const cleanDateStr = fechaOriginal.split("T")[0];
        const parts = cleanDateStr.split("-");
        if (parts.length === 3) {
          const year = parseInt(parts[0], 10);
          const month = parseInt(parts[1], 10) - 1;
          const day = parseInt(parts[2], 10);

          const f = new Date(year, month, day, 12, 0, 0);
          if (!isNaN(f.getTime())) {
            fechasPreventa.push(f);
          }
        }
      }
    });

    let dateFrom, dateTo;

    // 3. Regla de Negocio: Si hay preventa, manda la fecha más lejana. Si no, Hoy + 2 días
    if (fechasPreventa.length > 0) {
      dateFrom = new Date(Math.max(...fechasPreventa.map((f) => f.getTime())));
      dateTo = new Date(dateFrom);
      dateTo.setDate(dateFrom.getDate() + 1); // Rango de 1 día
    } else {
      const hoy = new Date();
      dateFrom = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() + 2, 12, 0, 0);
      dateTo = new Date(dateFrom);
      dateTo.setDate(dateFrom.getDate() + 1); // Rango de 1 día (Hoy + 3 días)
    }

    // Formateador ISO estricto: "YYYY-MM-DDT12:00:00-03:00"
    function toISOJanisFormat(date) {
      const pad = (num) => (num < 10 ? "0" : "") + num;
      return (
        date.getFullYear() + "-" +
        pad(date.getMonth() + 1) + "-" +
        pad(date.getDate()) + "T12:00:00-03:00"
      );
    }

    const newFrom = toISOJanisFormat(dateFrom);
    const newTo = toISOJanisFormat(dateTo);

    const currentCartFrom = cartData.attributes ? cartData.attributes["_janisCommerce_deliveryWindowFrom"] : null;
    const currentCartTo = cartData.attributes ? cartData.attributes["_janisCommerce_deliveryWindowTo"] : null;

    // 4. Actualizar atributos globales del carrito si cambian
    if (currentCartFrom !== newFrom || currentCartTo !== newTo) {
      const bodyParams = new URLSearchParams();
      bodyParams.append("attributes[_janisCommerce_deliveryWindowFrom]", newFrom);
      bodyParams.append("attributes[_janisCommerce_deliveryWindowTo]", newTo);

      await fetch((window.routes ? window.routes.cart_update_url : "/cart/update") + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: bodyParams
      });
    }

    // 5. Actualizar propiedades por línea de ítem
    const updates = {};
    let requiereUpdateItems = false;

    cartData.items.forEach((item) => {
      const properties = item.properties || {};
      const currentFrom = properties["_janisCommerce_deliveryWindowFrom"] || null;
      const currentTo = properties["_janisCommerce_deliveryWindowTo"] || null;

      if (currentFrom !== newFrom || currentTo !== newTo) {
        requiereUpdateItems = true;
        updates[item.key] = {
          properties: {
            ...properties,
            "_janisCommerce_deliveryWindowFrom": newFrom,
            "_janisCommerce_deliveryWindowTo": newTo
          }
        };
      }
    });

    if (requiereUpdateItems) {
      await fetch((window.routes ? window.routes.cart_update_url : "/cart/update") + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: updates })
      });
    }

  } catch (error) {
    console.error("Error al recalcular fechas Janis:", error);
  }
}

document.addEventListener("DOMContentLoaded", recalcularFechasJanis);
document.addEventListener("cart:updated", recalcularFechasJanis);
